import * as React from 'react';
import { connect } from 'react-redux';
import { IPackageListingAppState } from '../../redux-state';
import { updateAccessibleSeatingRequest } from '../../redux-state/actions/package-listing.actions';
import AccessibleSeatingView from '../../views/library/cart-accessible-seating.view';

interface StateToProps {
    accessibleSeatingLabel: string;
    accessibleSeatingText: string;
}

interface DispatchToProps {
    updateAccessibleSeatingRequest: (request: boolean) => void;
}

export type AccessibleSeatingProps = StateToProps & DispatchToProps;

export class AccessibleSeatingBase extends React.Component<AccessibleSeatingProps, any> {
    constructor(props: AccessibleSeatingProps) {
        super(props);
    }

    render() {
        return <AccessibleSeatingView {...this.props} />;
    }

}

function mapStateToProps(state: IPackageListingAppState, ownProps: AccessibleSeatingProps): StateToProps {
    return {
        accessibleSeatingLabel: state.packageListingText.accessibleSeatingLabel,
        accessibleSeatingText: state.packageListingText.accessibleSeatingText
    }
}

function mapDispatchToProps(dispatch, ownProps: AccessibleSeatingProps): DispatchToProps {
    return {
        updateAccessibleSeatingRequest: (request) => {
            dispatch(updateAccessibleSeatingRequest(request))
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(AccessibleSeatingBase);